module.exports = __webpack_public_path__ + "img/thealbum@2x.7e9afe05.png";